// Fade in Up Animation for text and components


const scrollElements = document.querySelectorAll(".fade-in");
const productImageElements = document.querySelectorAll(".product-image");

const elementInView = (el, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element) => {
  element.classList.add("show");
};

const hideScrollElement = (element) => {
  element.classList.remove("show");
};

//scroll
const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

//load
const handleLoadAnimation = () => {
  productImageElements.forEach((el) => {
      displayScrollElement(el);
  })
}

window.addEventListener("scroll", () => { 
  handleScrollAnimation();
});

window.addEventListener("load", () => { 
  handleLoadAnimation();
});